import React from 'react';
import { Text } from '@chakra-ui/react';

interface PropertyCopyTagProps {
	/** Whether this property is an archived clone the user kept — see {@link ClassifiedHouse.isCopy}. */
	isCopy?: boolean;
}

/**
 * Small "(copy)" marker shown next to a property's address when the property is an archived clone the
 * user kept after a professional-to-owner transfer: this one is the copy, the original now belongs to
 * the new owner. Renders nothing otherwise.
 *
 * Purely presentational — the `isCopy` flag is derived once at the data boundary (HouseContext) and
 * carried on the house, so this component needs no knowledge of the current user. Isolated so its
 * styling can be tweaked independently.
 */
const PropertyCopyTag: React.FC<PropertyCopyTagProps> = ({ isCopy }) => {
	if (!isCopy) return null;

	return (
		<Text as="span" fontSize="xs" flexShrink={0}>
			(copy)
		</Text>
	);
};

export default PropertyCopyTag;
